import {JackpotBetWidgetPCWrapperMRGreenBox} from "./jackpot-bet-widget-pc-wrapper.mrgreen.box";

export const JackpotBetWidgetPCWrapperMRGreenCisBox = JackpotBetWidgetPCWrapperMRGreenBox;